import { css } from '@emotion/react'
import Masonry from 'react-masonry-css'

import FeaturedFeedbackBox from './internal/FeaturedFeedbackBox'
import type { FeaturedFeedback } from './types'

const FeaturedFeedbackGrid: React.FC<{
  featuredFeedback: FeaturedFeedback[]
  viewingOwnProfile?: boolean
  compact?: boolean
  limit?: number
}> = ({
  featuredFeedback,
  viewingOwnProfile = false,
  compact = false,
  limit = Number.POSITIVE_INFINITY,
}) => {
  if (featuredFeedback.length === 0) {
    return null
  }
  featuredFeedback.sort((a, b) => -a.date.toMillis() + b.date.toMillis())
  const breakpoint = compact ? 992 : 769
  return (
    <Masonry
      breakpointCols={{
        default: 2,
        [breakpoint]: 1,
      }}
      className="shw-stories"
      columnClassName="shw-stories_column"
      css={css`
        display: flex;
        margin-left: -30px; /* gutter size offset */
        width: auto;

        .shw-stories_column {
          padding-left: 16px; /* gutter size */
          background-clip: padding-box;
        }
        .shw-stories_column > div {
          margin-bottom: 16px; /* space between items */
        }
      `}
    >
      {featuredFeedback.slice(0, limit).map(featuredFeedbackItem => (
        <FeaturedFeedbackBox
          key={`${featuredFeedbackItem.type}-${featuredFeedbackItem.id}`}
          feedback={featuredFeedbackItem}
          showFeedbackStar={
            viewingOwnProfile ? { featuredFeedbackCount: featuredFeedback.length } : null
          }
        />
      ))}
    </Masonry>
  )
}

export default FeaturedFeedbackGrid
